module.exports = __webpack_public_path__ + "static/media/ml-logo-footer.8abe5f79.png";